export class UserProfileDTO {
  public id?: number;
  public nickname?: string;
  public sex?: string;
  public externalId?: string;
}

export class UserProfile {
  private _id?: number;
  private _nickname?: string = "";
  private _sex?: string = "";
  private _externalId?: string = "";

  constructor(userProfile: UserProfileDTO) {
    this._id = userProfile.id;
    this._nickname = userProfile.nickname;
    this._sex = userProfile.sex;
    this._externalId = userProfile.externalId;
  }
}
